// eve-drawer-store — UI-State für den globalen EvePresenceDrawer.
//
// Zwei States:
//   - isOpen: ist der Drawer expandiert (Chat sichtbar) oder collapsed (nur
//     schmaler Composer am Boden)
//   - pendingPrompt + pendingOptions: wenn ein „Frag EVE"-Button auf einer
//     Page gedrückt wird, setzt er den Drawer auf open + legt die Frage hier
//     ab. Der Drawer liest sie beim Mount/Update und sendet sie.

import { create } from 'zustand';

export interface AskEveOptions {
  /** Was in der User-Chat-Bubble angezeigt wird. Wenn nicht gesetzt, zeigt
   *  der Chat den vollen `prompt` (der z.B. Fakten/Quellen enthält und ans
   *  LLM geht). Für Frag-EVE-Buttons gibst du hier die kurze Frage
   *  rein („Polymarket-Markt: '…'") und der lange Research-Prompt geht
   *  trotzdem an EVE. */
  displayText?: string;
  /** Unterdrueckt den LIVE_DATA_SNAPSHOT (Gesamtmarkt) im System-Prompt — fuer
   *  fokussierte Takes wie die Trending-Coin-Recherche, wo EVE sonst einen
   *  irrelevanten Makro-Dump raushaut. Default: Snapshot bleibt drin. */
  noLiveData?: boolean;
}

interface DrawerState {
  isOpen: boolean;
  pendingPrompt: string | null;
  pendingOptions: AskEveOptions | null;
  open: () => void;
  close: () => void;
  toggle: () => void;
  askEve: (prompt: string, options?: AskEveOptions) => void;
  consumePending: () => { prompt: string; options: AskEveOptions } | null;
}

export const useEveDrawerStore = create<DrawerState>((set, get) => ({
  isOpen: false,
  pendingPrompt: null,
  pendingOptions: null,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  askEve: (prompt, options) =>
    set({ isOpen: true, pendingPrompt: prompt, pendingOptions: options ?? null }),
  consumePending: () => {
    const p = get().pendingPrompt;
    if (!p) return null;
    const opts = get().pendingOptions ?? {};
    set({ pendingPrompt: null, pendingOptions: null });
    return { prompt: p, options: opts };
  },
}));
